import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";

const NotSupportedDevice = props => {
  const studioFind = GetSelectedCompanyStudio();
  return (
    document.documentElement.clientWidth < 1024 && (
      <div className="outer notSupported">
        <div className="middle">
          <div className="inner">
            <p
              style={{
                color: "#2a9dd6",
                fontSize: "22px",
                fontWeight: 100
              }}
            >
              <FontAwesomeIcon icon={["far", "info-circle"]} />{" "}
              <span style={{ marginLeft: "20px" }}>
                {studioFind?.taxRegion !== "ES" ? "Risoluzione schermo troppo bassa" : "Resolución de pantalla demasiado baja"}
              </span>
            </p>

            <p style={{ fontSize: "15.5px" }}>
              {studioFind?.taxRegion !== "ES" ? "La risoluzione del tuo schermo è sotto il minimo richiesto di 1024x768. Per favore ingrandisci il tuo schermo oppure modifica le preferenze di visualizzazione del monitor." : "La resolución de tu pantalla está por debajo del mínimo requerido de 1024x768. Por favor, aumenta el tamaño de tu pantalla o ajusta las preferencias de visualización del navegador o monitor."}
            </p>
            <br />
            <br />
            <FontAwesomeIcon
              icon={["far", "desktop"]}
              style={{
                fontSize: "40px",
                marginLeft: "20px",
                color: "#FC0"
              }}
            />
            <FontAwesomeIcon
              icon={["far", "tablet"]}
              style={{
                color: "#FC0",
                fontSize: "40px",
                marginLeft: "20px",
                transform: "rotate(90deg)"
              }}
            />
            <FontAwesomeIcon
              icon={["far", "tablet"]}
              style={{
                color: "#D1D1D1",
                fontSize: "40px",
                marginLeft: "20px"
              }}
            />
            <FontAwesomeIcon
              icon={["far", "mobile"]}
              style={{
                color: "#D1D1D1",
                fontSize: "40px",
                marginLeft: "20px"
              }}
            />
          </div>
        </div>
      </div>
    )
  );
};
export default NotSupportedDevice;
